export const queryKeys = {
  TOP_UNIVERSITIES: 'top-universities-info',
  ALL_UNIVERSITIES: 'all-universities',
  UNIVERSITIES_BALL: 'university-ball',
  UNIVERSITY_BY_ID: 'university-by-id',
  UNIVERSITY_BY_NAME: 'university-by-name',
  UNIVERSITY_COURSE: 'university-course',
  UNIVERSITIES_SORT: 'university-sort'
};
